import breakpoints from './breakpoints';
import colors from './colors';
import shadows from './shadows';
import spacing from './spacing';
import useMediaQuery from './useMediaQuery';

export default {
  breakpoints,
  colors,
  spacing,
  shadows,
  useMediaQuery,
};
